import React from 'react';
import Slider from 'react-slick';
import './HomeSolutions.scss';
import { renderCards } from '../../UI/Card/util/renderCards';

/**
 * Renders the solutions section on homepage
 * @param heading {String}
 * @param cards {Array<Object>}
 * @constructor
 */
const HomeSolutions = ({ heading, cards }) => {
  const settings = {
    dots: false,
    infinite: false,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          variableWidth: true,
        },
      },
    ],
  };

  return (
    <div className="c-home-solutions">
      <div className="c-home-solutions__content">
        <h3 className="c-home-solutions__heading color-black h2-roobert">{heading}</h3>

        <div className="c-home-solutions__cards">
          <Slider {...settings}>{renderCards(cards)}</Slider>
        </div>
      </div>
    </div>
  );
};

export default HomeSolutions;
